<template>
	<div>
		<div>
			<div class="blue white--text" style="padding: 8px; height: 59px; display: flex; align-items: center">
				<v-icon style="color: white; padding-right: 5px">
					{{icon}}
				</v-icon>
				<b style="font-size: 16px">
					{{text}} <span v-if="showPrintInfo" class="d-none print-only-inline"> (Wydruk próbny!)</span>
				</b>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "egrantySectionDivider",

		props: {
			icon: String,
			text: String,
			showPrintInfo: {
				type: Boolean,
				default: false
			}
		},
	};
</script>

<style scoped>
	.v-icon {
		color: #fff !important;
	}
	.v-toolbar-title  {
		background-color: #0075E2 !important;
	}

	.application.mediumFont b {
		font-size: 1.25em !important;
	}

	.application.largeFont b {
		font-size: 1.25em !important;
	}
</style>
